import React from 'react'

const AdminPublishers = () => {
  return (
    <div>AdminPublishers</div>
  )
}

export default AdminPublishers